// extracted by mini-css-extract-plugin
module.exports = {"root":"_2xv2N","title":"ItLky"};